import { PORTAL_UI_V2 } from "../config/uiTheme";
import MachineListLegacy from "./machines/MachineListLegacy";
import MachineListV2 from "./machines/MachineListV2";

const MachineList = () => (PORTAL_UI_V2 ? <MachineListV2 /> : <MachineListLegacy />);

export default MachineList;
